export const base = '/advanced-search*';
